import ScroolTop from "@base/ScrollTop/ScrollTop"

export default ScroolTop;
